import styled from "styled-components";



interface IProps {
  menuIsOpen: boolean;
}

export const Container = styled.div<IProps>`
  display: grid;
  transition: all .7s;
  grid-template-columns: min-content auto;
  grid-template-rows: auto minmax(0, 1fr);
  grid-template-areas:
  'aside header'
  'aside content';
  height: 100dvh;
  background: ${props => props.theme.colors.silverBG};
  overflow: hidden;
  position: relative;
  ${props => props.menuIsOpen && `
   
  `}
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-template-areas:
  'header'
  'content';
  }
`